export default {
  LATITUDE: 'latitude',
  ONLINE_STORE: 'onlinestore',
  DOMAIN: 'domain',
};
